import React from "react";
import PropTypes from "prop-types";
import Input from "../common/Input";
import SelectInput from "../common/SelectInput";
import { CLIENT_LEDGER_ENTRY_TYPES, PAYMENT_METHOD_OPTIONS } from "./clientLedgerTypes";

function ClientLedgerForm({
  entry,
  errors,
  onChange,
  onSubmit,
  isEditing,
  onCancel,
  showTypeSelector,
  fixedTypeLabel,
  settlementMonthReadOnly,
}) {
  return (
    <form id="client-ledger-form" onSubmit={onSubmit}>
      <div className="form-row">
        <div className="col-md-3">
          {showTypeSelector ? (
            <SelectInput
              label="Typ"
              name="type"
              value={entry.type}
              onChange={onChange}
              options={[
                { value: CLIENT_LEDGER_ENTRY_TYPES.PAYMENT, text: "Wplata" },
                { value: CLIENT_LEDGER_ENTRY_TYPES.OPENING_BALANCE, text: "Saldo poczatkowe" },
              ]}
              error={errors.type}
            />
          ) : (
            <div className="form-group">
              <span><strong>Typ</strong></span>
              <div className="form-control mt-1 bg-light">{fixedTypeLabel}</div>
            </div>
          )}
        </div>
        <div className="col-md-3">
          <Input type="date" label="Data" name="date" value={entry.date} onChange={onChange} error={errors.date} />
        </div>
        <div className="col-md-3">
          <Input
            label="Miesiac"
            name="settlementMonth"
            value={entry.settlementMonth}
            onChange={onChange}
            placeholder="YYYY-MM"
            readOnly={settlementMonthReadOnly}
          />
        </div>
        <div className="col-md-3">
          <Input label="Kwota" name="amount" value={entry.amount} onChange={onChange} error={errors.amount} />
        </div>
      </div>
      <div className="form-row">
        <div className="col-md-3">
          <SelectInput
            label="Metoda"
            name="method"
            value={entry.method}
            onChange={onChange}
            options={PAYMENT_METHOD_OPTIONS}
            defaultOption="Wybierz metode"
            error={errors.method}
          />
        </div>
        <div className="col-md-9">
          <Input label="Notatka" name="note" value={entry.note} onChange={onChange} />
        </div>
      </div>
      <button type="submit" className="btn manage-button manage-red-button mr-2">{isEditing ? "Zapisz zmiany" : "Dodaj wpis"}</button>
      {isEditing && (
        <button type="button" className="btn manage-button manage-teal-button" onClick={onCancel}>Anuluj</button>
      )}
    </form>
  );
}

ClientLedgerForm.propTypes = {
  entry: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isEditing: PropTypes.bool,
  onCancel: PropTypes.func,
  showTypeSelector: PropTypes.bool,
  fixedTypeLabel: PropTypes.string,
  settlementMonthReadOnly: PropTypes.bool,
};

ClientLedgerForm.defaultProps = {
  isEditing: false,
  onCancel: () => {},
  showTypeSelector: true,
  fixedTypeLabel: "Wplata",
  settlementMonthReadOnly: false,
};

export default ClientLedgerForm;
